import React from "react";
import { useLocalSearchParams } from 'expo-router';
import DigestEditorNative from '../../../(funnel)/digests/new';

export default function DiscoverProjectPage() {
  const { digestId } = useLocalSearchParams<{ digestId: string }>();

  // Pass digestId (mapped to projectId internally) to the component for editing existing projects
  // Use key to force React to unmount/remount when navigating between different projects
  return <DigestEditorNative key={digestId} projectId={digestId} />;
}
